export default "__VITE_ASSET__MjTNTHOi__"